module.exports = __webpack_public_path__ + "img/mijoz.dbbc803b.png";